export default [{
        name: 'login',
        path: '/login',
        meta: {
            logined: false,
            title: '登录'
        },

        component: resolve => require(['@/view/login/index.vue'], resolve)
    },
    // {
    //     name: 'register',
    //     path: '/register',
    //     meta: {
    //         logined: false,
    //         title: '注册'
    //     },
    //     component: resolve => require(['@/view/register/index.vue'], resolve)
    // },
    // {
    //     name: 'forgetpassword',
    //     path: '/forgetpassword',
    //     meta: {
    //         logined: false,
    //         title: '找回密码'
    //     },
    //     component: resolve => require(['@/view/forgetpassword/index.vue'], resolve)
    // },
    // {
    //     name: 'forgetpasswordemail',
    //     path: '/forgetpasswordemail',
    //     meta: {
    //         logined: false,
    //         title: '找回密码'
    //     },
    //     component: resolve => require(['@/view/forgetpasswordemail/index.vue'], resolve)
    // },
    // {
    //     name: 'forgetpasswordemailsign',
    //     path: '/forgetpasswordemailsign',
    //     meta: {
    //         logined: true,
    //         title: '找回密码'
    //     },
    //     component: resolve => require(['@/view/forgetpasswordemailsign/index.vue'], resolve)
    // },
    // {
    //     name: 'forgetpasswordmobile',
    //     path: '/forgetpasswordmobile',
    //     meta: {
    //         logined: false,
    //         title: '找回密码'
    //     },
    //     component: resolve => require(['@/view/forgetpasswordmobile/index.vue'], resolve)
    // },
    
    {
        name: 'publish',
        path: '/publish',
        meta: {
            title: '发表'
        },
        redirect: '/publish/article',
        component: resolve => require(['@/view/publish/default/index.vue'], resolve),
        beforeEnter: (to, from, next) => {
            //保存来源router
            localStorage.setItem('topublishfromrouter', from.path);
            next();
        },
        children: [{
                name: 'article',
                path: 'article',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/publish/publishtext/index.vue'], resolve)
            },
            {
                name: 'video',
                path: 'video',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/publish/publishvideo/index.vue'], resolve)
            },
            {
                name: 'image',
                path: 'image',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/publish/publishimages/index.vue'], resolve)
            },
            {
                name: 'publishInformation',
                path: '/information/article',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/publish/publishInformation/index.vue'], resolve)
            },
            {
                name: 'editePublishInformation',
                path: '/information/edite/:id',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/publish/publishInformation/index.vue'], resolve)
            }
        ]
    },
    {
        name: 'main',
        path: '/',
        meta: {
            title: ''
        },
        component: resolve => require(['@/view/index.vue'], resolve),
        children: [{
                name: 'home',
                path: '',
                meta: {
                    title: ''
                },
                component: resolve => require(['@/view/home/index.vue'], resolve)
            },
            {
                name: 'ad',
                path: '/ad',
                meta: {
                    title: '广告'
                },
                component: resolve => require(['@/view/ad/index.vue'], resolve)
            },
            {
                name: 'manageContent',
                path: '/manage/content',
                meta: {
                    title: '内容管理'
                },
                component: resolve => require(['@/view/manage/content/index.vue'], resolve)
            },
            {
                name: 'manageSlide',
                path: '/manage/slide',
                meta: {
                    title: '幻灯管理'
                },
                component: resolve => require(['@/view/manage/slide/index.vue'], resolve)
            },
            {
                name: 'manageSlideEnter',
                path: '/manage/slide/enter',
                meta: {
                    title: '素材管理保存'
                },
                component: resolve => require(['@/view/manage/slide/enter/index.vue'], resolve)
            },
            {
                name: 'manageAnnouncement',
                path: '/manage/announcement',
                meta: {
                    title: '公告管理'
                },
                component: resolve => require(['@/view/manage/announcement/index.vue'], resolve)
            },
            {
                name: 'manageContentaudit',
                path: '/manage/contentaudit',
                meta: {
                    title: '内容审核管理'
                },
                component: resolve => require(['@/view/manage/contentaudit/index.vue'], resolve)
            },
            {
                name: 'manageFixedContent',
                path: '/manage/fixedcontent',
                meta: {
                    title: '返修管理'
                },
                component: resolve => require(['@/view/manage/fixedcontent/index.vue'], resolve)
            },
            {
                name: 'tagword',
                path: '/manage/tagword',
                meta: {
                    title: '栏目管理'
                },
                component: resolve => require(['@/view/manage/tagword/index.vue'], resolve)
            },
            {
                name: 'manageWatermark',
                path: '/manage/watermark',
                meta: {
                    title: '水印管理'
                },
                component: resolve => require(['@/view/manage/watermark/index.vue'], resolve)
            },
            {
                name: 'manageConfiguration',
                path: '/manage/configuration',
                meta: {
                    title: '系统配置'
                },
                component: resolve => require(['@/view/manage/Configuration/index.vue'], resolve)
            },
            {
                name: 'manageComment',
                path: '/manage/comment',
                meta: {
                    title: '评论管理'
                },
                component: resolve => require(['@/view/manage/comment/index.vue'], resolve)
            },
            {
                name: 'manageContentdetail',
                path: '/manage/commentdetail',
                meta: {
                    title: '评论管理详情'
                },
                component: resolve => require(['@/view/manage/commentdetail/index.vue'], resolve)
            },
            {
                name: 'manageStudio',
                path: '/manage/studio',
                meta: {
                    title: '育人号管理'
                },
                component: resolve => require(['@/view/manage/studio/index.vue'], resolve)
            },
            {
                name: 'Single',
                path: '/manage/studio/:id',
                meta: {
                    title: '育人号管理编辑'
                },
                component: resolve => require(['@/view/manage/studio/single/index.vue'], resolve)
            },
            {
                name: 'sameProvince',
                path: '/manage/sameProvince',
                meta: {
                    title: '省级台账管理'
                },
                component: resolve => require(['@/view/manage/sameStandingBook/index.vue'], resolve)
            },
            {
                name: 'differentProvince',
                path: '/manage/differentProvince',
                meta: {
                    title: '思政司台账管理'
                },
                component: resolve => require(['@/view/manage/differentStandingBook/index.vue'], resolve)
            },
            {
                name: 'workScheduling',
                path: '/manage/workScheduling',
                meta: {
                    title: '工作调度'
                },
                component: resolve => require(['@/view/manage/workScheduling/index.vue'], resolve)
            },
            {
                name: 'ledger',
                path: '/manage/ledger',
                meta: {
                    title: '台账更新'
                },
                component: resolve => require(['@/view/manage/ledger/index.vue'], resolve)
            },
            {
                name: 'StudioworkScheduling',
                path: '/work/workScheduling',
                meta: {
                    title: '育人号工作调度'
                },
                component: resolve => require(['@/view/manage/studioWorkScheduling/index.vue'], resolve)
            },
            {
                name: 'StudioLedger',
                path: '/work/studioLedger',
                meta: {
                    title: '育人号台账列表'
                },
                component: resolve => require(['@/view/manage/studioLedger/index.vue'], resolve)
            },
            {
                name: 'fixedForm',
                path: '/manage/fixedForm',
                meta: {
                    title: '固定表单管理'
                },
                component: resolve => require(['@/view/manage/fixedForm/index.vue'], resolve)
            },
            {
                name: 'formRecord',
                path: '/manage/formRecord',
                meta: {
                    title: '表单记录'
                },
                component: resolve => require(['@/view/manage/formRecord/index.vue'], resolve)
            },
            {
                name: 'information',
                path: '/information',
                meta: {
                    title: '消息通知'
                },
                component: resolve => require(['@/view/information/index.vue'], resolve)
            },
            // {
            //     name: 'constructioninfo',
            //     path: '/manage/differentProvince/info/:id/:type',
            //     meta: {
            //         title: '建设计划书-查看'
            //     },
            //     component: resolve => require(['@/view/manage/differentStandingBook/single/index.vue'], resolve)
            // },
            {
                name: 'constructionView',
                path: '/manage/differentProvince/new/:id/:type',
                meta: {
                    title: '数据采集表-查看'
                },
                component: resolve => require(['@/view/manage/differentStandingBook/newinfo/index.vue'], resolve)
            },
            {
                name: 'constructionView',
                path: '/manage/differentProvince/:id/:type',
                meta: {
                    title: '数据采集表-查看'
                },
                component: resolve => require(['@/view/manage/differentStandingBook/info/index.vue'], resolve)
            },
            
            {
                name: 'proviceStudio',
                path: '/manage/proviceStudio',
                meta: {
                    title: '省级育人号管理'
                },
                component: resolve => require(['@/view/manage/proviceStudio/index.vue'], resolve)
            },
            {
                name: 'SourceMaterial',
                path: '/manage/material',
                meta: {
                    title: '素材管理'
                },
                component: resolve => require(['@/view/manage/material/index.vue'], resolve)
            },
            {
                name: 'SourceMaterialEnter',
                path: '/manage/material/enter',
                meta: {
                    title: '素材管理保存'
                },
                component: resolve => require(['@/view/manage/material/enter/index.vue'], resolve)
            },
            {
                name: 'manageAd',
                path: '/manage/ad',
                meta: {
                    title: '广告管理'
                },
                component: resolve => require(['@/view/manage/ad/index.vue'], resolve)
            },
            {
                name: 'SourceDatabase',
                path: '/manage/database',
                meta: {
                    title: '学校库管理'
                },
                component: resolve => require(['@/view/manage/database/index.vue'], resolve)
            },
            {
                name: 'manageAccount',
                path: '/manage/account',
                meta: {
                    title: '账号管理'
                },
                component: resolve => require(['@/view/manage/account/index.vue'], resolve)
            },
            {
                name: 'manageAccountSingle',
                path: '/manage/account/:id',
                meta: {
                    title: '校账号管理编辑'
                },
                component: resolve => require(['@/view/manage/account/single/index.vue'], resolve)
            },
            {
                name: 'settingsAccount',
                path: 'settings/account',
                meta: {
                    title: '账号信息'
                },
                component: resolve => require(['@/view/settings/account/index.vue'], resolve)
            },
            {
                name: 'message',
                path: '/message',
                meta: {
                    title: '消息设置'
                },
                component: resolve => require(['@/view/message/index.vue'], resolve)
            },
            {
                name: 'draftcount',
                path: '/manage/draftcount',
                meta: {
                    title: '发稿数管理'
                },
                component: resolve => require(['@/view/manage/draftcount/index.vue'], resolve)
            },
            {
                name: 'manageDraftcountSingle',
                path: '/manage/draftcount/:id',
                meta: {
                    title: '发稿数设置'
                },
                component: resolve => require(['@/view/manage/draftcount/single/index.vue'], resolve)
            },
            {
                name: 'wechataddsuccess',
                path: 'wechatadd/success',
                meta: {
                    title: '微信绑定成功'
                },
                component: resolve => require(['@/view/channel/wechatadd/wxaddsuccess/index.vue'], resolve)
            },
            {
                name: 'channelMInput',
                path: 'channel/minput',
                meta: {
                    title: '渠道'
                },
                redirect: { path: '/channel/minput/wechatlist', query: { type: 'input' } },
                component: resolve => require(['@/view/channel/channelminput/index.vue'], resolve),
                children: [{
                        name: 'miwechatlist',
                        path: 'wechatlist',
                        meta: {
                            title: '渠道-微信内容源'
                        },
                        component: require('@/view/channel/wechatlist/index.vue')
                    },
                    {
                        name: 'miwebsitelist',
                        path: 'websitelist',
                        meta: {
                            title: '渠道-网站内容源'
                        },
                        component: require('@/view/channel/websitelist/index.vue')
                    }
                ]
            },
            {
                name: 'channelEInput',
                path: 'channel/einput',
                meta: {
                    title: '渠道'
                },
                redirect: { path: '/channel/einput/wechatadd', query: { type: 'input' } },
                component: resolve => require(['@/view/channel/channeleinput/index.vue'], resolve),
                children: [{
                        name: 'eiwechatadd',
                        path: 'wechatadd',
                        meta: {
                            title: '渠道-微信内容源'
                        },
                        component: require('@/view/channel/wechatadd/index.vue')
                    },
                    {
                        name: 'eiwebsiteadd',
                        path: 'websiteadd',
                        meta: {
                            title: '渠道-网站内容源'
                        },
                        component: require('@/view/channel/websiteadd/index.vue')
                    }
                ]
            },
            {
                name: 'channelMOutput',
                path: 'channel/moutput',
                meta: {
                    title: '渠道'
                },
                redirect: { path: '/channel/moutput/wechatlist', query: { type: 'output' } },
                component: resolve => require(['@/view/channel/channelmoutput/index.vue'], resolve),
                children: [{
                        name: 'momicrobloglist',
                        path: 'microbloglist',
                        meta: {
                            title: '渠道-微博'
                        },
                        component: require('@/view/channel/microbloglist/index.vue')
                    },
                    {
                        name: 'mowechatlist',
                        path: 'wechatlist',
                        meta: {
                            title: '渠道-微信'
                        },
                        component: require('@/view/channel/wechatlist/index.vue')
                    }
                ]
            },
            {
                name: 'channelEOutput',
                path: 'channel/eoutput',
                meta: {
                    title: '渠道'
                },
                redirect: { path: '/channel/eoutput/wechatadd', query: { type: 'output' } },
                component: resolve => require(['@/view/channel/channeleoutput/index.vue'], resolve),
                children: [{
                        name: 'eowechatadd',
                        path: 'wechatadd',
                        meta: {
                            title: '渠道-微信'
                        },
                        component: require('@/view/channel/wechatadd/index.vue')
                    },
                    {
                        name: 'eomicroblogadd',
                        path: 'microblogadd',
                        meta: {
                            title: '渠道-微博'
                        },
                        component: require('@/view/channel/microblogadd/index.vue')
                    }
                ]
            },
            {
                name: 'settingsBasic',
                path: 'settings/basic',
                meta: {
                    title: '基本信息'
                },
                component: resolve => require(['@/view/settings/basic/index.vue'], resolve)
            },

            {
                name: 'SourceLive',
                path: '/manage/live',
                meta: {
                    title: '直播管理'
                },
                component: resolve => require(['@/view/manage/live/index.vue'], resolve)
            },
            {
                name: 'SourceLiveEnter',
                path: '/manage/live/enter',
                meta: {
                    title: '直播管理保存'
                },
                component: resolve => require(['@/view/manage/live/enter/index.vue'], resolve)
            },
            {
                name: 'SourceFusionaudit',
                path: '/manage/fusionaudit',
                meta: {
                    title: '育人号审核'
                },
                component: resolve => require(['@/view/manage/fusionaudit/index.vue'], resolve)
            },
            {
                name: 'DataStatisticsContent',
                path: 'datastatistics/content',
                redirect: 'datastatistics/content/summary',
                meta: {
                    title: '数据统计'
                },
                component: resolve => require(['@/view/datastatistics/content/index.vue'], resolve),
                children: [{
                        name: 'datasummary',
                        path: 'summary',
                        meta: {
                            title: '数据统计-概况'
                        },
                        component: resolve => require(['@/view/datastatistics/content/summary/index.vue'], resolve)
                    },
                    {
                        name: 'exponential',
                        path: 'exponential',
                        meta: {
                            title: '数据统计-育人号指数'
                        },
                        component: resolve => require(['@/view/datastatistics/content/exponential/index.vue'], resolve)
                    },
                    //       {
                    //          path: 'articlesDetail',
                    //          component: resolve => require(['@/view/datastatistics/content/articliesDetail/index.vue'], resolve)
                    //       },
                    //  {
                    //     path: 'video',
                    //     meta: {
                    //         title: '数据统计-视频分析'
                    //       },
                    //     component: resolve => require(['@/view/datastatistics/content/video/index.vue'], resolve)
                    //  },
                    //       {
                    //          path: 'videoDetail',
                    //          component: resolve => require(['@/view/datastatistics/content/videoDetail/index.vue'], resolve)
                    //       },

                    //  {
                    //     path: 'headlines',
                    //     meta: {
                    //         title: '数据统计-头条分析'
                    //       },
                    //     component: resolve => require(['@/view/datastatistics/content/headlines/index.vue'], resolve)
                    //  }
                ]
            },

            {
                name: 'DataStatisticsContentArticliesDetail',
                path: '/datastatistics/content/articliesDetail',
                meta: {
                    title: '数据统计-内容分析-文章详情'
                },
                component: resolve => require(['@/view/datastatistics/content/articliesDetail/index.vue'], resolve)
            },
            {
                name: 'DataStatisticsContentVideoDetail',
                path: '/datastatistics/content/videoDetail',
                meta: {
                    title: '数据统计-内容分析-视频详情'
                },
                component: resolve => require(['@/view/datastatistics/content/videoDetail/index.vue'], resolve)
            },
            {
                name: 'DataStatisticsFans',
                path: 'datastatistics/fans',
                redirect: 'datastatistics/fans/summary',
                meta: {
                    title: '数据统计-粉丝分析'
                },
                component: resolve => require(['@/view/datastatistics/fans/index.vue'], resolve),
                children: [{
                        name: 'fansummary',
                        path: 'summary',
                        meta: {
                            title: '粉丝分析-概况'
                        },
                        component: resolve => require(['@/view/datastatistics/fans/summary/index.vue'], resolve)
                    },
                    {
                        name: 'attribute',
                        path: 'attribute',
                        meta: {
                            title: '粉丝分析-粉丝属性'
                        },
                        component: resolve => require(['@/view/datastatistics/fans/attribute/index.vue'], resolve)
                    },
                    {
                        name: 'search',
                        path: 'search',
                        meta: {
                            title: '粉丝分析-兴趣探索'
                        },
                        component: resolve => require(['@/view/datastatistics/fans/search/index.vue'], resolve)
                    },
                    {
                        name: 'fanslist',
                        path: 'fanslist',
                        meta: {
                            title: '粉丝分析-粉丝列表'
                        },
                        component: resolve => require(['@/view/datastatistics/fans/fanslist/index.vue'], resolve)
                    }
                ]
            },
            {
                name: 'DataStatisticsSort',
                path: 'datastatistics/sort',
                meta: {
                    title: '数据统计-育人号指数'
                },
                component: resolve => require(['@/view/datastatistics/sort/index.vue'], resolve)
            },
            {
                name: 'letterstation/list',
                path: '/letterstation/list',
                meta: {
                    title: '私信-列表'
                },
                component: resolve => require(['@/view/letterstation/list/index.vue'], resolve)
            },
            {
                name: 'letterstation/talk',
                path: '/letterstation/talk',
                meta: {
                    title: '私信-对话'
                },
                component: resolve => require(['@/view/letterstation/talk/index.vue'], resolve)
            },
            {
                name: 'letterstation/rule',
                path: '/letterstation/rule',
                meta: {
                    title: '私信-规则'
                },
                component: resolve => require(['@/view/letterstation/rule/index.vue'], resolve)
            },
            {
                name: 'work',
                path: '/system/work',
                meta: {
                    title: '工作简报'
                },
                component: resolve => require(['@/view/system/work/index.vue'], resolve)
            },
        ]
    },
    {
        name: 'personal',
        path: '/personal',
        meta: {
            title: '提交建设申请'
        },
        component: resolve => require(['@/view/apply/index.vue'], resolve),
    },
    {
        name: 'fixedTable',
        path: '/fixedTable',
        meta: {
            title: '工作调度管理'
        },
        component: resolve => require(['@/view/fix/index.vue'], resolve)
    },
    {
        name: 'fixedPreview',
        path: '/share/preview',
        meta: {
            logined: false,
            title: '文档预览'
        },
        component: resolve => require(['@/view/fix/preview/index.vue'], resolve)
    },
    {
        name: 'shareForm',
        path: '/share/form/:id',
        meta: {
            logined: false,
            title: '分享工作调度'
        },
        component: resolve => require(['@/view/fix/index.vue'], resolve)
    },
    {
        name: 'fixedPreview',
        path: '/share/prospectus/:token',
        meta: {
            logined: false,
            title: '台账计划书'
        },
        component: resolve => require(['@/view/fix/preview/index.vue'], resolve)
    },
    {
        name: 'article',
        path: '/article/:id',
        meta: {
            title: ''
        },
        component: resolve => require(['@/view/article/index.vue'], resolve)
    },
    {
        name: 'informationArticle',
        path: '/information/article/:id',
        meta: {
            title: ''
        },
        component: resolve => require(['@/view/messageArticle/index.vue'], resolve)
    },
    {
        name: 'scanlist',
        path: '/scan/list',
        meta: {
            logined: false,
            title: '文章列表'
        },
        component: resolve => require(['@/view/scan/index.vue'], resolve)
    },
    {
        name: 'scan',
        path: '/scan/:id',
        meta: {
            logined: false,
            title: '预览'
        },
        component: resolve => require(['@/view/scan/detail/index.vue'], resolve)
    },
    {
        name: 'notice',
        path: '/notice/:id',
        meta: {
            title: '公告'
        },
        component: resolve => require(['@/view/notice/index.vue'], resolve)
    },
    {
        name: 'share',
        path: '/share/:id',
        meta: {
            logined: false,
            title: '分享'
        },
        component: resolve => require(['@/view/share/index.vue'], resolve)
    },
    {
        name: 'DataStatisticsContentArticliesDetail',
        path: '/datastatistics/content/articliesDetail',
        meta: {
            title: '数据统计-内容分析-文章详情'
        },
        component: resolve => require(['@/view/datastatistics/content/articliesDetail/index.vue'], resolve)
    },
    {
        name: 'DataStatisticsContentVideoDetail',
        path: '/datastatistics/content/videoDetail',
        meta: {
            title: '数据统计-内容分析-视频详情'
        },
        component: resolve => require(['@/view/datastatistics/content/videoDetail/index.vue'], resolve)
    },
    
    {
        name: '500',
        path: '/500',
        meta: {
            title: '500'
        },
        component: resolve => require(['@/view/500/index.vue'], resolve)
    },
    {
        name: '404',
        path: '*',
        meta: {
            title: '404'
        },
        component: resolve => require(['@/view/404/index.vue'], resolve)
    }
]


// WEBPACK FOOTER //
// ./src/router/routers.js